<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>We may update this Privacy Policy periodically to reflect changes in:</p>
    <ul class="list-disc list-inside">
      <li>Technology</li>
      <li>Business practices</li>
      <li>Legal requirements</li>
    </ul>
    <p>Any updates will be posted on this page with a new “Last Updated” date.</p>
  </div>
</template>